<template>
<div>
    <!-- Controls (Always Visible) -->
    <v-row align="center" class="mb-4">
        <v-col cols="auto" class="d-flex align-center">
            <v-btn
                color="primary"
                @click="onClickAddPaymentMethod"
                class="mr-4"
                :disabled="pays_with_check"
            >
                <v-icon left>mdi-plus</v-icon>
                Add Payment Method
            </v-btn>

            <v-switch
                v-model="show_archived"
                label="Show archived"
                hide-details
                color="primary"
                @change="update"
                class="mt-1"
            ></v-switch>
        </v-col>

        <v-col class="text-right">
            <span class="grey--text">
                {{ results.length }} payment method{{ results.length !== 1 ? 's' : '' }}
            </span>
        </v-col>
    </v-row>

    <!-- Loading Overlay -->
    <div class="position-relative">
        <v-overlay
            :value="loading"
            absolute
            opacity="0.3"
        >
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-overlay>

        <v-fade-transition mode="out-in">
            <!-- Empty State -->
            <v-card
                v-if="results.length == 0 && show_help_when_no_payment_methods && !show_archived"
                class="text-center pa-6"
                outlined
                key="empty"
            >
                <v-icon size="64" color="grey lighten-1" class="mb-4">mdi-credit-card-outline</v-icon>
                <h3 class="text-h6 font-weight-medium grey--text text--darken-2">No payment methods have been added yet</h3>
                <p class="grey--text">RedChirp supports credit cards and US bank accounts</p>

            </v-card>

            <!-- Payment Methods List -->
            <div v-else key="list">
                <m-redchirp-payment-method
                    v-for="(item, index) in results"
                    :key="item.payment_method_id || index"
                    :value="item"
                    :pays_with_check="pays_with_check"
                    @update="update"
                />

                <!-- No Results Message -->
                <v-card
                    v-if="results.length === 0"
                    outlined
                    class="text-center pa-4 grey lighten-4"
                >
                    <div class="d-flex align-center justify-center">
                        <v-icon color="grey">mdi-archive-outline</v-icon>
                        <span class="ml-2 grey--text text--darken-1">No payment methods to display.</span>
                    </div>
                </v-card>
            </div>
        </v-fade-transition>
    </div>
</div>
</template>

<script>
export default {
    props: {
        organization_id: {
            type: String,
            default: function() { return null; }
        },

        show_help_when_no_payment_methods: {
            type: Boolean,
            default: function() { return true; }
        },

        payment_method: {
            type: String,
            default: function() { return null; }
        },
    },

    data() {
        return {
            results: [],
            show_archived: false,
            loading: true
        }
    },

    computed: {
        pays_with_check() {
            return this.payment_method === 'check';
        }
    },

    mounted () {
        this.update();
    },

    methods: {
        update() {
            this.loading = true;
            this.$rc.rest({
                'spinner': false, // We're using our own loading indicator
                'endpoint': 'LIST: /api/v1/organizations/red-chirp-payments',

                'params' : {
                        'organization_id': this.organization_id,
                        'show_archived': this.show_archived,
                    },

                'on_success': (data) => {
                        this.results = data.results;
                        this.loading = false;
                    },

                'on_error': (error) => {
                        this.$rc.alert('Error', 'Unable to list your payment methods: ' + error);
                        this.loading = false;
                    },
            });
        },

        onClickAddPaymentMethod()
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PUT: /api/v1/organizations/red-chirp-payments/start-add-stripe',

                'params' : {
                        'after_url': ''+window.location,
                        'organization_id': this.organization_id,
                    },

                'on_success': (data) => {
                        window.location = data.url;
                    },

                'on_error': 'Unable to add payment method.',
            });
        },


    },
}
</script>

<style lang="scss" scoped>
.position-relative {
  position: relative;
}
</style>